if (!customElements.get('sticky-add-to-cart')) {
  customElements.define(
    'sticky-add-to-cart',
    class StickyAddToCart extends HTMLElement {
      connectedCallback() {
        this.targetButton = document.querySelector('product-info .product-form__submit');
        this.sourcePriceEl = document.querySelector('product-info [id^="price-"]');
        this.ownButton = this.querySelector('.sticky-atc__button');
        this.priceEl = this.querySelector('.sticky-atc__price');
        this.sizeChip = this.querySelector('.sticky-atc__size-chip');
        this.sizeSheet = this.querySelector('.sticky-atc__size-sheet') || document.getElementById('StickyATC-SizeSheet');

        // חשוב: מוציאים את שכבת בחירת המידה מתוך הפס אל <body>.
        // ל-.sticky-atc יש transform, ולכן הוא containing block לכל position:fixed שבתוכו —
        // מה שכלא את השכבה בגודל הפס וב-z-index: 10, מתחת לווידג'ט הנגישות.
        this.detachSizeSheet();

        this.sizeSheetBody = this.sizeSheet?.querySelector('.sticky-atc__size-sheet-body');
        this.sizeSheetClose = this.sizeSheet?.querySelector('.sticky-atc__size-sheet-close');
        this.sizeSheetBackdrop = this.sizeSheet?.querySelector('.sticky-atc__size-sheet-backdrop');

        if (!this.targetButton) return;

        this.setupObserver();
        this.setupSync();
        this.setupClick();
        this.setupSizeSelector();
      }

      detachSizeSheet() {
        if (!this.sizeSheet) return;
        // אם נשארה שכבה ישנה מ-render קודם — מסירים אותה כדי שלא יהיו כפילויות
        document.querySelectorAll('body > .sticky-atc__size-sheet').forEach((el) => {
          if (el !== this.sizeSheet) el.remove();
        });
        if (this.sizeSheet.parentElement !== document.body) {
          document.body.appendChild(this.sizeSheet);
        }
      }

      setupObserver() {
        this.observer = new IntersectionObserver(
          (entries) => {
            const entry = entries[0];
            const visible = !entry.isIntersecting;
            this.classList.toggle('sticky-atc--visible', visible);
            document.body.classList.toggle('sticky-atc-a11y-shift', visible);
          },
          { threshold: 0 }
        );
        this.observer.observe(this.targetButton);
      }

      setupSync() {
        const syncDisabled = () => {
          if (!this.ownButton) return;
          const disabled = this.targetButton.hasAttribute('disabled');
          this.ownButton.disabled = disabled;
          this.ownButton.classList.toggle('disabled', disabled);
        };

        new MutationObserver(syncDisabled).observe(this.targetButton, {
          attributes: true,
          attributeFilter: ['disabled'],
        });
        syncDisabled();

        if (this.priceEl && this.sourcePriceEl) {
          const syncPrice = () => {
            const priceText = this.getVisiblePriceText();
            if (priceText) this.priceEl.textContent = priceText;
            this.updateSizeChipLabel();
          };
          new MutationObserver(syncPrice).observe(this.sourcePriceEl, {
            childList: true,
            subtree: true,
            characterData: true,
            attributes: true,
            attributeFilter: ['class'],
          });
          syncPrice();
        }
      }

      getVisiblePriceText() {
        if (!this.sourcePriceEl) return '';
        const onSale = this.sourcePriceEl.classList.contains('price--on-sale');
        const selector = onSale ? '.price__sale .price-item--sale' : '.price__regular .price-item--regular';
        const el = this.sourcePriceEl.querySelector(selector);
        return el ? el.textContent.replace(/\s+/g, ' ').trim() : '';
      }

      setupClick() {
        if (!this.ownButton) return;
        this.ownButton.addEventListener('click', () => {
          if (this.targetButton && !this.targetButton.disabled) {
            this.targetButton.click();
          }
        });
      }

      setupSizeSelector() {
        this.realVariantPicker = document.querySelector('product-info variant-selects, product-info variant-radios');
        if (!this.sizeChip || !this.sizeSheet || !this.realVariantPicker) return;

        this.sizeChip.hidden = false;
        this.updateSizeChipLabel();

        this.sizeChip.addEventListener('click', () => this.openSizeSheet());
        this.sizeSheetClose?.addEventListener('click', () => this.closeSizeSheet());
        this.sizeSheetBackdrop?.addEventListener('click', () => this.closeSizeSheet());

        this.sizeSheetBody.addEventListener('change', (event) => {
          const target = event.target;
          if (target && target.matches('input[type="radio"], select')) {
            this.applySizeSelection(target);
          }
        });

        this.realVariantPicker.addEventListener('change', () => {
          this.updateSizeChipLabel();
        });
      }

      renderSizeSheetContent() {
        const picker = document.querySelector('product-info variant-selects, product-info variant-radios');
        if (!picker || !this.sizeSheetBody) return;
        this.realVariantPicker = picker;
        this.sizeSheetBody.innerHTML = picker.innerHTML;
        this.remapIds(this.sizeSheetBody, 'StickyATCSheet-');
      }

      remapIds(root, prefix) {
        root.querySelectorAll('[id]').forEach((el) => {
          const oldId = el.id;
          const newId = prefix + oldId;
          el.id = newId;
          root.querySelectorAll('[for="' + CSS.escape(oldId) + '"]').forEach((label) => {
            label.setAttribute('for', newId);
          });
        });
      }

      applySizeSelection(sheetInput) {
        if (!this.realVariantPicker) return;
        const name = sheetInput.name;
        const value = sheetInput.value;
        let realInput;

        if (sheetInput.tagName === 'SELECT') {
          realInput = this.realVariantPicker.querySelector('select[name="' + CSS.escape(name) + '"]');
          if (realInput) {
            realInput.value = value;
            realInput.dispatchEvent(new Event('change', { bubbles: true }));
          }
        } else {
          realInput = this.realVariantPicker.querySelector(
            'input[name="' + CSS.escape(name) + '"][value="' + CSS.escape(value) + '"]'
          );
          if (realInput) {
            realInput.checked = true;
            realInput.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }

        this.updateSizeChipLabel();
        window.setTimeout(() => this.closeSizeSheet(), 250);
      }

      updateSizeChipLabel() {
        if (!this.sizeChip) return;
        const valueEl = this.sizeChip.querySelector('.sticky-atc__size-chip-value-text');
        if (!valueEl) return;

        const chooseLabel = this.sizeChip.dataset.chooseLabel || valueEl.textContent;

        const picker = document.querySelector('product-info variant-selects, product-info variant-radios');
        if (!picker) return;

        const values = [];
        picker.querySelectorAll('fieldset').forEach((fieldset) => {
          const checked = fieldset.querySelector('input[type="radio"]:checked');
          if (checked) values.push(checked.value);
        });
        picker.querySelectorAll('select').forEach((select) => {
          const opt = select.options[select.selectedIndex];
          if (opt && select.value) values.push(opt.value);
        });

        valueEl.textContent = values.length ? values.join(' / ') : chooseLabel;
      }

      openSizeSheet() {
        this.detachSizeSheet();
        // מציבים את השכבה אחרונה ב-body כדי שתצויר מעל אלמנטים עם אותו z-index מקסימלי
        if (document.body.lastElementChild !== this.sizeSheet) {
          document.body.appendChild(this.sizeSheet);
        }
        this.renderSizeSheetContent();
        this.sizeSheet.hidden = false;
        requestAnimationFrame(() => this.sizeSheet.classList.add('sticky-atc__size-sheet--open'));
        document.body.style.overflow = 'hidden';
        // מנטרל זמנית את הלחיצה על כפתור הנגישות, כמו כל אלמנט שמאחורי מודאל
        document.body.classList.add('sticky-atc-sheet-open');
      }

      closeSizeSheet() {
        this.sizeSheet.classList.remove('sticky-atc__size-sheet--open');
        document.body.style.overflow = '';
        window.setTimeout(() => {
          this.sizeSheet.hidden = true;
          // משחררים רק אחרי שהשכבה נעלמה לגמרי, כדי שקליק "רפאים"
          // שמגיע באיחור אחרי הבחירה לא ייפול על כפתור הנגישות
          document.body.classList.remove('sticky-atc-sheet-open');
        }, 400);
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
        document.body.classList.remove('sticky-atc-a11y-shift');
        document.body.classList.remove('sticky-atc-sheet-open');
        if (this.sizeSheet && this.sizeSheet.parentElement === document.body) {
          this.sizeSheet.remove();
        }
      }
    }
  );
}
